import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import RoleForm from './RoleForm';
import { defaultConfigComponent } from './Roles';

const roleSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  //ownerOrganizationId: yup.string().required().label('Owner of organization'),
});

const RolePage = props => {
  return (
    <CrudPage
      key={'rolePage'}
      configComponent={defaultConfigComponent}
      essentialValues={new Set(['aclPrivileges'])}
      form={RoleForm}
      validationSchema={roleSchema}
    />
  );
};

export default RolePage;
